import axios from 'axios'
const forceVerifyEmailForUserMigratedFromCognito = async (cognitoJWT, firebaseJWT) => {
  await axios.post('/ali/force-verify-email-for-cognito-migration', {
    cognitoJWT,
    firebaseJWT
  })
}

export default forceVerifyEmailForUserMigratedFromCognito
